import { ID } from "../../features/core/utils";
import { ChatbotConversation } from "./models/ChatbotMsg";
import { ChatConversationStatus } from "./models/ChatConstants";

export const botMsgColor = '#0C2032';

export const getConversationStatus = (conversationId: ID, conversations: ChatbotConversation[]) => {
    let conversationIndex = conversations.findIndex(c => c.id == conversationId)
    if(conversationIndex == -1){
        return ChatConversationStatus.DISABLED
    }
    return conversations[conversationIndex].status
}

export const currentConversationIsPending = (conversationId: ID, conversations: ChatbotConversation[]) => {
    // let conversationIndex = conversations.findIndex(c => c.id == conversationId)
    // if(conversationIndex == -1){
    //     return false
    // }
    // return conversations[conversationIndex].pending
}